import React, { ReactElement } from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import SharedButton from "@components/severalbrands/sharedButton";
import style from "./style.module.scss";
import { DomainInfo } from "@components/severalbrands/utils/services";
export type MainImgTextSharedComponentElType = {
    mainTitle: string;
    secondTitle?: string;
    paragraphs: (string | JSX.Element)[];
    img?: string;
    mainSectionClassName?: string;
    secondSectionClassName?: string;
    mainTitleClassName?: string;
    secondTitleClassName?: string;
    textClassName?: string;
    imgClassName?: string;
    imgToLeft?: boolean;
    showLogos?: boolean;
    showButton?: boolean;
    mainH1Element?: boolean;
};
export default function MainSharedComponent({
    info,
    domainInfo,
}: {
    info: MainImgTextSharedComponentElType;
    domainInfo?: DomainInfo;
}): ReactElement {
    return (
        <motion.section
            transition={{ duration: 1.5 }}
            initial={{ opacity: 0, y: 150 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={`flex flex-col lg:flex-row  ${
                info.mainSectionClassName ? info.mainSectionClassName : ""
            } `}
        >
            <div
                className={` ${
                    info.img ? "3xl:max-w-[800px] max-w-[500px]" : ""
                } mx-auto lg:mx-0 ${
                    info.imgToLeft ? "order-2 lg:order-2" : "order-2 lg:order-1"
                } ${
                    info.secondSectionClassName
                        ? info.secondSectionClassName
                        : ""
                }`}
            >
                {info.mainH1Element ? (
                    <h1
                        className={`font-bold 3xl:text-5xl lg:text-3xl 3xl:leading-[4rem] text-xl lg:leading-10 text-[#351C4F] ${
                            info.mainTitleClassName
                                ? info.mainTitleClassName
                                : ""
                        } `}
                    >
                        {info.mainTitle}
                    </h1>
                ) : (
                    <h2
                        className={`font-bold 3xl:text-5xl lg:text-3xl 3xl:leading-[4rem] text-xl lg:leading-10 text-[#351C4F] ${
                            info.mainTitleClassName
                                ? info.mainTitleClassName
                                : ""
                        } `}
                    >
                        {info.mainTitle}
                    </h2>
                )}

                {info.secondTitle && (
                    <h3
                        className={`3xl:text-4xl lg:text-2xl text-lg font-bold ${
                            info.secondTitleClassName
                                ? info.secondTitleClassName
                                : ""
                        }`}
                    >
                        {info.secondTitle}
                    </h3>
                )}

                {info.paragraphs?.map((pInfo, index) => (
                    <div
                        key={index}
                        className={`3xl:mt-6 lg:mt-4 mt-3 3xl:text-3xl 3xl:leading-[3rem] lg:text-xl  text-base lg:leading-8 font-light ${
                            info.textClassName ? info.textClassName : ""
                        }`}
                    >
                        {pInfo}
                    </div>
                ))}
                {info.showButton && (
                    <div className="mt-9">
                        <SharedButton
                            pdf
                            href="https://cdn.severalbrands.com/attachments/2025/02/severalbrands_resources.pdf"
                        >
                            Download Your Free PDF
                        </SharedButton>
                    </div>
                )}

                {info.showLogos && (
                    <ul
                        className={`flex 3xl:mt-10 mt-5 justify-center gap-10 flex-wrap`}
                    >
                        {domainInfo?.config?.sliderLogos?.default?.map(
                            (logo) => (
                                <li
                                    key={logo.slug}
                                    className={`w-[100px] h-[22px]  3xl:w-[150px] 3xl:h-[34px] relative ${style["imgStyle"]}`}
                                >
                                    <Image
                                        src={logo.path}
                                        alt={logo.slug}
                                        layout="fill"
                                        objectFit="contain"
                                    />
                                </li>
                            ),
                        )}
                    </ul>
                )}
            </div>

            {info.img && (
                <div
                    className={`${
                        info.imgClassName ? info.imgClassName : ""
                    }   mx-auto lg:mx-0  ${
                        info.imgToLeft
                            ? "order-1 lg:order-1"
                            : "order-1 lg:order-2"
                    }`}
                >
                    <Image
                        src={info.img}
                        alt="img"
                        layout="fill"
                        objectFit="contain"
                    />
                </div>
            )}
        </motion.section>
    );
}
